import { useCallback, useEffect, useState } from 'react'

import { exposeStrapiError } from 'utils'
import { ReadMyCertificates } from 'services/certificates'

export default function useController() {
  const [certificates, setCertificates] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  const load = useCallback(async () => {
    setLoading(true)
    const result = await ReadMyCertificates()
    if (exposeStrapiError(result)) {
      setError('Your certificates could not be loaded. Please try again.')
    } else {
      setCertificates(Array.isArray(result?.data) ? result.data : [])
      setError('')
    }
    setLoading(false)
  }, [])

  useEffect(() => { load() }, [load])

  return { certificates, loading, error, retry: load }
}
